// extracted by mini-css-extract-plugin
module.exports = {"navButton":"nav-button_navButton__1tH1a","title":"nav-button_title__3hZF5","active":"nav-button_active__3Td1q"};